module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-three"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }), _c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("“A")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("t first man wandered the earth with little thought as to the great beyond, to right or wrong, and the way that he should live. Then came the White Buffalo Woman. Two hunters were out one day, and she appeared. She was very beautiful, dressed in white skins, and she carried something in a pack that she wore on her back. Now, when I say beautiful, she was stunning. And one of the hunters thought, ‘Hmm, now there’s a woman I would like to have in my tepee,’” Brent Blackhawk said, scanning the eyes of his audience.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Have in his tepee?” one of the older boys teased lightly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Do you mean date?” asked one of the girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Something like that,” Brent said dryly. “But, you see, she was the White Buffalo Woman, and not to be taken lightly. She saw that the hunter had designs on her, so she crooked her finger toward him, and thinking himself the big and mighty hunter and warrior, he approached her. But as he did so, white fog rolled out around the both of them. And when it dissipated, the great and mighty warrior had been turned to bone. And as the bones fell to the earth, they were covered with snakes that writhed and crawled among them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Ugh!” cried one of the younger girls.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What happened then?” asked the older boy who had heckled him before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Ah, well, the other hunter was naturally amazed—and more than a little afraid. But the woman told him to hurry to his village and tell the elders, chiefs, shamans and all the people that she was coming, and that she had a message to give that all must heed. The hunter hurried to the village and relayed his story, and everyone—from the great chief to the smallest child—dressed in his and her best and gathered in the great tepee as if for a council, and awaited her. She came, beautiful in her white, carrying the bundle that she had previously worn on her back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And what then?” asked a boy of about eleven.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “First she took a stone from the bundle and set it on the ground. Then she took out a pipe. It had a red stone bowl, the color of the earth, and she said that it stood for the earth. There was a calf carved upon it, and the carving stood not just for the calf but for all the creatures that walked the earth. The stem of the pipe was wood, and that stood for all things that grew. There were beautiful feathers attached to the pipe, and they stood not just for the hawks and eagles, but for all the birds that flew in the sky. When she had explained all this, she said that those who smoked the pipe would learn about relationships—first, with the Wakantanka, had come before them, grandfather, grandmother, father, mother, and those who would follow, sons and daughters. All relatives were bound as one and meant to be honored. All the earth was sacred and to be cared for. All were to be respected.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The boy of eleven looked troubled.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What is it?” Brent asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’re not supposed to smoke,” the boy told him solemnly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent smiled. “You’re Michael?” he asked, trying to remember all the names.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Michael Tiger,” the boy said proudly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Michael, you’re right. Smoking isn’t just very bad for your health, it’s an expensive and annoying habit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Then how can anyone smoke the sacred pipe?” the girl at Brent’s side asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent lowered his head, smiling. “The sacred pipe is now part of a ceremony. There are very specific times when the pipe may be smoked among the Lakotas, you see.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You never finished the story,” another of the girls pointed out.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Ah, yes,” Brent said. “Well, the rest of the story relates to what we’re saying now. The stone that the White Buffalo Woman put down at first had seven little cuts in it. They indicated those very special times when the pipe might be smoked, ceremonies to honor all that she was teaching. They would be part of the relationships that the people must learn so that they would not be like animals, wandering the earth, without care for it or those around them. When she had taught them a bit more, she walked a few steps away. Then she turned into a brown and white calf. Again she walked, and this time she became a white calf. After a few more feet, she became a great black buffalo. She left the council tepee and walked up a hill and there she bowed to the four corners of the earth, north and south, east and west, and then…”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And then?” Michael Tiger demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She vanished,” Brent said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But…why did she come, if she was only going to disappear?” Michael asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She came to teach the people to respect and care for one another, for the earth itself, and for all creatures, and for all the gifts that were given to man, even the stones and the river and the ground,” Brent said. He smiled, rising. “That is the Lakota legend of the White Buffalo Woman.” He swept an arm out, indicating the many people who were attending the festival, a gathering of tribes deep in the Florida Everglades. It wasn’t a reenactment of the old days—vendors sold soda, popcorn, tribal T-shirts, corn dogs and other non-native foods, while rock bands filled the air with sounds that would certainly have shocked the White Buffalo Woman. He’d come with a group called the Wild Chieftains, and since he had something of a reputation as a storyteller, he’d been asked to tell a few legends to the children. They weren’t all Indian, and that pleased him. The children represented local tribes, such as the Miccosukee and Seminole, along with Cree, Creek, Cherokee and others. There were also a number of African-Americans, Hispanics and whatever mix the so-called “whites” might be. He’d heard British and German accents in the crowd, so even the tourists had come out for the festival.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The truth is, every group has its own legend. The Great Spirit is God to some and Allah to others. There are many paths a man—or woman—might take to reach the same place. The important part of the story is that we all need to respect and take care of one another, and respect the earth, as well,” Brent said, grinning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then his grin faded as he looked past the children, and saw, in the group of adults standing behind them, a familiar face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A too-familiar face. That of a man he knew well.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" But hadn’t he been expecting him?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are you really a Lakota?” one of the little girls asked him. “Your eyes are green.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Oh, Heidi,” Michael Tiger said, sighing, as if he were possessed of a great deal more wisdom than she, a younger child, and a ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("girl.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “My sister’s eyes are blue, because my stepmother is mostly German. People mix up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Was your mother mostly German?” the girl asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He grinned. “Irish,” he told her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But your father was all Lakota?” Michael asked hopefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “How about this—my grandfather, Chief Soaring Blackhawk, was all Lakota,” Brent said. He could feel the eyes of Adam Harrison boring into him as he spoke. He could also see the man’s smile. Adam was very much enjoying the way the children were putting him on the spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is it easier to be only half Indian?” Susan asked, her tone serious.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent ignored Adam for a moment, hunkering down in front of the little girl. “Let’s hope that very soon it won’t matter whether we’re red, black, tan, yellow, white…male or female. Or whether we believe in the White Buffalo Woman, the teachings of Buddha, Allah or God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah!” The little girl turned to stare at Michael.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She is really smart,” Michael told Brent grudgingly. “She makes the best grades in school. Especially in math.” He made a face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I said I’d help you,” the girl protested.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent had a feeling he was watching a budding romance. “Take her up on it, eh, Tiger?” he said, and smiling, he waved a hand, starting away from the group that had gathered around him. His departure was acknowledged with a nice round of applause. He smiled, waved again, and Adam caught up with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’ve got quite a talent there,” Adam told him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent shrugged. “Kids like fables from any land, about any people.” He stopped walking and stared at Adam. “All right, why did you track me down?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I need you to go to New Orleans.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent groaned inwardly as a wave of dread washed over him. He avoided New Orleans like the plague. Not that he disliked the city. It was full of wonderful people, great food, incredible music.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But it was one of the places a man such as himself should never go.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “New Orleans,” he muttered bitterly. He stared at Adam, shoving his hands into his pockets. “I’m supposed to be back at the Pine Ridge Reservation on Tuesday,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’re needed?” Adam said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Every man is needed,” Brent told him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Adam smiled, looking away from the area where the festival was taking place, out to the rich areas of sawgrass that seemed to stretch forever, though the road, the Tamiami Trail, was really within a few hundred feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Your eyes ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" green,” Adam commented, looking at him again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And what is that supposed to mean?” Brent asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Well, I just listened to you give the most marvelous speech to those children. About acceptance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Adam smiled. “Heritage is a wonderful thing. The Irish arrived after a potato famine. Italians poured into the country in the 1920s. Cubans and South Americans and immigrants from the Caribbean all came to South Florida. You know what happens after we’re all here a while? We become Americans.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent had to smile. “And…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “My point is the one you were just making. We’re all many things. You’re more Irish than you are Lakota. You’re just an American.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “So you should support your heritage—all of it. You teach, you counsel…and then you have your special gifts. Your mother was full-blooded Irish, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is that a comment on my ‘gift’?” Brent asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s a comment on the fact that you’re a mongrel, like most people. And right now the mixed-up all-American part of you is needed,” Adam said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “In New Orleans?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Adam looked away for a moment. “Look, I know how you feel about New Orleans. I wouldn’t ask you if I didn’t believe this was important.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s where Tania died,” Brent said quietly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I know. I said that I wouldn’t have asked you if it weren’t important.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “A lot of things are important.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I need you, Brent.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You have other people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Adam hesitated. “You know I always weigh what I need to do very carefully. And in this circumstance, I need you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I assume you’re going to explain?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The government lost an agent.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent was still puzzled, and he said softly, “I’m not without sympathy, Adam, but agents put their lives on the line. And sometimes they die.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “This agent was seen walking around—after he’d been killed,” Adam said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent arched a brow. “All right,” he said after a moment. “I guess you’re going to tell me all of it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m going to tell you everything I know,” Adam assured him solemnly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And I’m going to guess that I already have a plane ticket?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You leave tomorrow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“The new Storyville district is a great place to visit,” Nikki assured the crowd around her. “As in the past, there’s music and great food, but you won’t find the same…business that flourished years ago. Alderman Sydney Story knew he couldn’t get rid of the oldest profession as it’s been called, but he was hoping to control it. I can’t imagine he was happy when the red light district he worked so hard to contain was named Storyville, after him. The district limited prostitution and, in time, other vices to the area from the south side of Customhouse Street to the north side of St. Louis Street, from the lower side of North Basin Street to the lower side of Robertson Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “There are endless tales to go with the area. The bordellos ranged from the poor and ragged to the rich and classy, the girls from young and green to long in the tooth. But the true reigning queen of Storyville was Josie. She was born just about the end of the Civil War, raised by a very religious family, and seduced at an early age into the arms of a fancy man. But at heart, Josie was an entrepreneur. In her early days, she was red-haired and wild-tempered, and her place was known for some of the fiercest and most entertaining catfights to be seen anywhere. Then, when the brawling became too much even for Josie, she reinvented herself and ran ads for ladies of the highest rank. She managed to make a fortune and buy herself a splendid home in an affluent quarter of the city. Eventually she became obsessed with death. Not that she seemed to be terribly worried about her immortal soul. She was consumed, however, with concern regarding her physical remains. She wanted to be as grand in death as she presumed herself to be in life. So she had a tomb built, a truly magnificent tomb. It incorporated pilasters and urns and torches. And a beautiful sculpture of a woman, one foot on a step, her hand reaching for the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “In time Josie died and was entombed. But an heir squandered away her money. Her house was sold, as was her tomb. The new owners did not want her remains, so they were removed. In New Orleans, after a year and a day, that’s no problem. Where they lie today…it’s one of the best-kept secrets of the cemetery. But it’s often said that Josie’s spirit slips into the statue of the woman that still stands at the entry to her former tomb. Is she trying to get into heaven? Or merely beckoning others to follow her? If you happen to see the elegant statue moving, don’t be afraid. Josie had a temper, but she was also a social creature, and it’s said that she’s merely visiting gentlemen callers who happened to have ended their days in the same cemetery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Where is the tomb?” a slender woman called to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Metairie. It’s featured on another of our tours, and we hope you’ll join us for it,” Nikki replied. “Well, folks, that’s it for the evening, except that my colleagues—the tall, dark handsome fellow there, Julian, and the beautiful young woman to my right, Andrea—will join me in answering any questions you might have. And thank you so much for joining us. There are many tour groups here in New Orleans, so we hope we’ve fulfilled your expectations, and enlightened and entertained you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The usual round of questions followed. Nikki never minded, but that night, she knew, she was glancing at her watch. At last she was able to extricate herself from the last family eager to learn more.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It had been a good evening. In fact, it had been a good day. Her ridiculous sense of foreboding hadn’t meant a thing. When she finished with the family, she waved to Andy and Julian, and they headed off for Pat O’Brien’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Man, I have never seen so many posters up before an election,” Julian commented as they passed the wooden barricade around a construction site. The posters advertised the current sensation, an older man named Harold Grant. “He looks like you, Nikki. Far too serious,” Julian teased. “Maybe we need new blood running the place. Have you seen all the posters for what’s-his-name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Billy Banks,” Andy reminded him. “Yeah, and he’s a cutie. Have you seen him, Nikki? Vibrant guy, lots of charisma. Poor old Harold probably doesn’t have a chance against him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Some people don’t vote for a candidate because he’s cute,” Nikki said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Julian shrugged. “They’re both swearing they’re the one who can clean up crime in the parish,” he said. “Politicians. Who do you believe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “None of them,” Andy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey…lots of people out tonight,” Julian said, forgetting politics as they neared their destination.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Despite the popularity of the place—an absolute must for tourists—they were able to garner a table. It was almost as if Max could see them in his mind’s eye from wherever he was, because they had just started on their first round of Hurricanes when Nikki’s cell rang.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Drunk yet?” Max asked her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Funny,” she told him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A soft chuckle came over the phone. “Come on, kid. Celebrate. Let yourself go. Drop down among the mortals and do a little sinning, huh?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Who is it?” Mitch asked, over the din.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is it Max?” Julian demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She nodded, pressing the phone closer to her ear and mouthing, “He wants to know if we’re drunk yet. He’s telling us to celebrate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Tell him I’m on my way to happily inebriated—since he’s picking up the tab,” Nathan yelled, slipping an arm around Patricia’s shoulder. “And Tricia’s doing fine, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hot time tonight, huh?” Julian asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Patricia laughed. “Like he needs to get me drunk at this point.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Just…perky,” Nathan teased, hugging her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Would you guys quit with the sex thing? At least until you see the rest of us coupled up for the night, huh?” Mitch said. “By the way, Nikki, make sure you’re hearing Max correctly. He’s telling you to celebrate, not to be celibate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Funny, Mitch,” she mouthed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What was that Mitch said?” Max asked. He said something else, but the music was playing and there were voices all around.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki waved a hand at them, frowning. “I can’t hear you, Max,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The others ignored her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You won’t see me coupled up—not in the near future,” Andy said. “A voodoo queen warned me to watch out for strangers,” she assured them")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Max?” Nikki said, narrowing her eyes fiercely at the others.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m here, Nick,” he said. “I just called to say that you’re doing a great job—one of the travel magazines just rated us as the top tour bargain in the Big Easy. So tell Nathan to drink himself silly. And you do the same.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She realized that the idea actually appealed to her. What had it been? The weird junkie at Madame’s yesterday? That sense of foreboding this morning? The back-to-back tours she had done that day? She needed to take it a little easier. Once Max got back, she was going to tell him that they needed to hire more people.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The Hurricane she had assumed she would nurse all night was already empty. A waitress replaced it without being asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She smiled her thanks and spoke to her boss.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Max, thanks, that’s great. I’ll tell the others.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Tell us what?” Patricia demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She waved an impatient hand again, trying to get them to shut up while she was still talking.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “When are you coming back?” she asked Max. “I need to ask you—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Do what you need to do. I’m not sure yet when I’m coming back. You’ve got my cell—call me with any problems. And for tonight, let loose. Eat, drink and be merry. We’ll talk soon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Max—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He’d hung up.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What did he say?” Julian demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She told them about their ranking in the tourist mag. A cheer went up, and then a toast. “Did we order food?” Nikki demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Our little China doll is getting tipsy!” Patricia teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki groaned. “Hey, for real.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey, for real,” Julian assured her. “We’ve got a shrimp and crawfish appetizer coming, gumbo and a special thing, pork, red beans and rice…succotash, darlin’!” he teased, managing to sound just like Max.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thank God,” she murmured.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Indeed. Another toast,” Nathan said, raising his glass. “We’re the best. And congrats to Nikki, our blonde beauty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey, don’t look now, but that guy over there is looking to be a couple tonight,” Patricia said, nodding toward the other side of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “He’s looking at Nikki, not me,” Andy said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nikki twisted around. The guy in question was nice looking, sandy-haired, either a businessman letting down his hair, or maybe a college student.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I think he’s looking at you, Andy,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Ladies, ladies, I hate to disappoint you, but I think he’s looking at me,” Mitch said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Another round of drinks came to the table. Nikki’s head was beginning to buzz, but it was a celebration, and she did need to let loose now and then.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" So she ate crawfish and had another Hurricane, and laughed at the banter around the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The plane rose, angling into the air.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Below, there was light.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Along the coast, the highly populated sections were ablaze with artificial light. Housing and commercial development were pushing the boundaries, eating up great chunks of the Everglades.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And yet the great area of no-man’s-land remained, thick with grass and slow-moving water—and darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" South Florida. From the air, it was easy to see just how much of the landscape was still taken up by the “river of grass,” since, technically, the Glades weren’t swampland at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Brent loved it, loved the festivals held by the Seminole and Miccosukee Indians. He loved playing guitar with his friends. Loved the seemingly endless expanse of the Glades, even with the mosquitoes, snakes and alligators.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The Everglades made a great place to dump bodies, too. When someone went missing…well, the police knew where to look.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This was his home now, the place he’d chosen to live. But there was also the home of his childhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" After the deaths of his parents, his grandfather had been his legal guardian, so he’d spent a great deal of time, school vacations, holidays, summers, in South Dakota. But his mom’s family had been among many Irish immigrants to the Deep South, and until recently, they’d lived in the parish of his birth. Most of the time when he’d been growing up had been spent with that side of his family, in Louisiana.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" New Orleans. The French Quarter. Where he’d been born.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He knew the area far too well.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" New Orleans. And beyond the Vieux Carré, the bayous. Endless canals. Alligators, shrimp and shrimpers, crawfish, Cajun food…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There were bodies there, too. And strange events that went beyond the accepted norm…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was what he did, he reminded himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But not always by choice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" New Orleans.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Damn, but he hated to go home.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1cc8e82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter-04.vue
// module id = 78
// module chunks = 0